// @flow

import React from 'react';
import { Glyphicon, Button, FormGroup, ControlLabel, FormControl, Col, ListGroupItem } from 'react-bootstrap';

type Props = {
  label: string,
  name: string,
  data: string | number,
  handleEditState: Function
};
export default (props: Props) => {
  return (
    <ListGroupItem  className={props.name === 'holdLuggage' && 'before-header-split' }
    >
      <FormGroup controlId={props.name}>
        <Col componentClass={ControlLabel} xs={4}>
          <div style={{ width: '120%' }}>{props.label}</div>
        </Col>
        <Col xs={6}>
          <FormControl.Static className="">{props.data}</FormControl.Static>
        </Col>
        <Col xs={2} className="text-right" style={{ marginLeft: '-23px' }}>
          {props.type === "date" ? null :
          (<Button
            bsStyle="link"
            style={{ whiteSpace: 'nowrap', marginRight: '-10px' }}
            onClick={() => props.handleEditState(props.name)}
          >
            <Glyphicon style={{ fontSize: '1rem' }} glyph="edit" /> edit
          </Button>)
          }
        </Col>
      </FormGroup>
    </ListGroupItem>
  );
};



// WEBPACK FOOTER //
// ./src/components/GeneralDataField/index.js